import { Link, useNavigate } from 'react-router-dom';
import gugo from '../assets/gugo.svg';
import bet from '../assets/bet.svg';
import { useState } from 'react';
import Login from '../pages/auth-pages/Login';
import Registration from '../pages/auth-pages/Registration';
import { updateAuth } from '../redux/authSlice';
import { useDispatch, useSelector } from 'react-redux';
import MobileMenu from './MobileMenu';
import { Globe } from 'lucide-react';
import { Typography } from '@mui/material';

export default function Navbar() {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const openLogin = useSelector(state => state.auth.openLogin);
    const openRegister = useSelector(state => state.auth.openRegister);

    const onClickItem = (btn) => {
        if (btn === 'Login') dispatch(updateAuth({ openLogin: true }));
        else dispatch(updateAuth({ openRegister: true }));
    }

    const onClickLangSelector = () => {
        dispatch(updateAuth({ openLanguage: true }))
    }

    return (
        <nav className="bg-[#0B1622] md:h-[65px] border-b border-[#66a1ff33] sticky top-5 z-20">
            <div className="pe-4 pb-3 md:pb-0">
                <div className="block md:flex items-center justify-between">
                    <div className="flex items-center h-16">
                        <MobileMenu />
                        <Link to="/" className="flex-shrink-0">
                            <div className='flex'>
                                <img src={gugo} width={60} alt="" />
                                <img src={bet} width={38} alt="" />
                            </div>
                        </Link>
                        <button className="flex items-center gap-1 rounded-md bg-[#1c2d44] px-3 py-[6px] ms-2 text-white"
                            onClick={onClickLangSelector}>
                            <Globe size={20} />
                            <Typography>EN</Typography>
                        </button>
                    </div>
                    <div className="flex items-center ps-2 space-x-4 top-16 w-full md:w-1/4 justify-end">
                        <button variant="outline" className="text-[#022367] text-base w-[30%] bg-[#D6D6D6] rounded-xl font-semibold py-2"
                            onClick={() => onClickItem('Login')}>
                            Login
                        </button>
                        <button className="text-white text-base w-[65%] rounded-xl font-semibold py-2 box-shadow-register registeration-btn-bg"
                            onClick={() => onClickItem('Register')}>
                            Registration
                        </button>
                    </div>
                </div>
            </div>
            {openLogin && <Login />}
            {openRegister && <Registration />}
        </nav>
    )
}


